import {useEffect, useState} from 'react';
import {
  TwitchExtensionConfiguration,
  usePulsoidClient,
  Widget,
} from '../../PulsoidClient';
import {Widgets} from '@pulsoid-private/widgets-lib';
import {trim} from 'lodash';

type TwitchExtensionWidgetSelectorComponentProps = {
  configuration: TwitchExtensionConfiguration;
};

export const TwitchExtensionWidgetSelectorComponent = (
  props: TwitchExtensionWidgetSelectorComponentProps
) => {
  let client = usePulsoidClient();
  let [layout, setLayout] = useState(props.configuration.v1Layout);
  let [widgets, setWidgets] = useState<Widget[]>([]);

  useEffect(() => {
    async function fetch() {
      let widgets = await client.getAllWidgets();
      widgets.filter((widget) => {
        if (Widgets.find((w) => w.metaId == widget.metaId)) {
          return true;
        }
        return false;
      });
      setWidgets(widgets);
    }

    fetch();
  }, []);

  return (
    <>
      <h5>Widget Selector</h5>
      <select
        value={layout?.containers[0]?.widgetId ?? 'none'}
        onChange={async (e) => {
          let widgetId = e.target.value;
          if (widgetId == 'none') {
            return;
          }

          let container: any;
          if (layout?.containers[0]) {
            container = {...layout?.containers[0], widgetId};
          } else {
            container = {
              id: 'some-id-' + getRandomInt(10000),
              widgetId: widgetId,
              x: 100,
              y: 100,
              width: 200,
              height: 200,
            };
          }

          let response =
            await client.addOrUpdateTwitchExtensionV1LayoutContainer(container);
          setLayout(response.configuration.v1Layout);
        }}
      >
        <option value={'none'}>None</option>
        {widgets.map((widget) => {
          return (
            <option value={widget.id} key={widget.id}>
              {widget.note.name}-{widget.note.description}
            </option>
          );
        })}
      </select>
    </>
  );
};

function getRandomInt(max: number) {
  return Math.floor(Math.random() * max);
}
